import React from "react";
import { Container, Box, Typography, Card, CardContent, CardActions, CircularProgress } from "@mui/material";

import { MyBusinessIcon, MyGroupAddIcon, MyHelpIcon, MyShieldIcon } from "../Assets/svg/MyIcons";

const UnauthorizedIPPage = ({ loading }) => {
  return (
    <Box
      className="position-relative d-flex align-items-center justify-content-center"
      sx={{
        minHeight: "100vh",
        overflow: "hidden",
        p: 3,
      }}
    >
      {/* Soft Background Gradient */}
      <Box
        className="position-absolute w-100 h-100 top-0 start-0"
        sx={{
          background: "linear-gradient(135deg, #d6e0ff, #f6f9fc 60%)",
          opacity: 0.95,
          zIndex: -2,
        }}
      />

      {/* Floating Decorative Blobs */}
      <Box
        className="position-absolute rounded-circle"
        sx={{
          width: "22rem",
          height: "22rem",
          top: "20%",
          left: "20%",
          background: "rgba(80,120,200,0.20)",
          filter: "blur(50px)",
          animation: "blobPulse 7s infinite",
          zIndex: -1,
        }}
      />

      <Box
        className="position-absolute rounded-circle"
        sx={{
          width: "19rem",
          height: "19rem",
          bottom: "15%",
          right: "22%",
          background: "rgba(80,200,170,0.20)",
          filter: "blur(55px)",
          animation: "blobPulse 8s infinite",
          animationDelay: "1.5s",
          zIndex: -1,
        }}
      />

      <Container>
        {loading ? (
          // Loading Spinner
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: "90vh" }}
          >
            <CircularProgress
              sx={{ color: "#344d95" }}
              size={60}
            />
          </div>
        ) : (
          <Card
            className="shadow"
            sx={{
              maxWidth: 620,
              mx: "auto",
              borderRadius: 3,
              overflow: "hidden",
              backdropFilter: "blur(6px)",
            }}
          >
            {/* Top Border Highlight */}
            <Box
              sx={{
                height: 8,
                background: "linear-gradient(135deg, #9bb8ff, #e3e8ff)",
              }}
            />

            <CardContent sx={{ p: 4, textAlign: "center" }}>
              {/* Shield Icon Section */}
              <Box
                sx={{
                  width: 95,
                  height: 95,
                  mx: "auto",
                  borderRadius: "50%",
                  bgcolor: "#e9f0ff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: 2,
                  mb: 3,
                  animation: "scaleIn 0.5s ease-out",
                }}
              >
                <MyShieldIcon
                  size={42}
                  color="#005a56"
                />
              </Box>

              {/* Title */}
              <Typography
                variant="h4"
                fontWeight="bold"
                gutterBottom
                sx={{ color: "#0a2332" }}
              >
                Access Restricted
              </Typography>

              {/* Subtitle */}
              <Typography
                variant="body1"
                sx={{ color: "#1e4946", mb: 3 }}
              >
                Your IP address is not authorized to access this portal.
              </Typography>

              {/* Divider with label */}
              <Box className="d-flex align-items-center my-3 text-secondary">
                <Box sx={{ flex: 1, borderBottom: "1px solid #b8d4d1" }}></Box>
                <Typography
                  variant="body2"
                  sx={{ mx: 2, color: "#0d4b45", fontWeight: 500 }}
                >
                  What can you do?
                </Typography>
                <Box sx={{ flex: 1, borderBottom: "1px solid #b8d4d1" }}></Box>
              </Box>

              {/* Action List */}
              <Box
                component="ul"
                sx={{ listStyle: "none", p: 0, maxWidth: 450, mx: "auto" }}
              >
                {/* Item 1 */}
                <Box
                  component="li"
                  className="d-flex align-items-center py-2"
                  sx={{ color: "#003b38" }}
                >
                  <MyGroupAddIcon
                    size={22}
                    color="#006d66"
                    style={{ marginRight: 12 }}
                  />
                  <Typography variant="body2">Contact your administrator to request access.</Typography>
                </Box>

                {/* Item 2 */}
                <Box
                  component="li"
                  className="d-flex align-items-center py-2"
                  sx={{ color: "#003b38" }}
                >
                  <MyBusinessIcon
                    size={22}
                    color="#006d66"
                    style={{ marginRight: 12 }}
                  />
                  <Typography variant="body2">Ensure you're connected to your company’s secure network.</Typography>
                </Box>

                {/* Item 3 */}
                <Box
                  component="li"
                  className="d-flex align-items-center py-2"
                  sx={{ color: "#003b38" }}
                >
                  <MyHelpIcon
                    size={22}
                    color="#006d66"
                    style={{ marginRight: 12 }}
                  />
                  <Typography variant="body2">Check if you are using a permitted VPN connection.</Typography>
                </Box>
              </Box>
            </CardContent>

            {/* Footer */}
            <CardActions
              sx={{
                justifyContent: "center",
                bgcolor: "#f8f9fc",
                py: 2,
                borderTop: "1px solid #e1e5eb",
              }}
            >
              <Typography
                variant="body2"
                sx={{ color: "#6c757d" }}
              >
                © {new Date().getFullYear()} QBot by Netclues.
              </Typography>
            </CardActions>
          </Card>
        )}
      </Container>

      {/* Animations */}
      <style>{`
        @keyframes blobPulse {
          0%, 100% { opacity: .6; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.15); }
        }
        
        @keyframes scaleIn {
          0% { transform: scale(.7); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </Box>
  );
};

export default UnauthorizedIPPage;
